function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M56.354 4.354a.5.5 0 0 0 0-.708L53.172.464a.5.5 0 1 0-.707.708L55.293 4l-2.828 2.828a.5.5 0 1 0 .707.708l3.182-3.182zM0 4.5h56v-1H0v1z",
  fill: "#000"
});

const SvgArrowLong = props => React.createElement("svg", _extends({
  width: 57,
  height: 8,
  fill: "none"
}, props), _ref);

export default SvgArrowLong;